/**
 * Search Collections Renderer
 * Renders collection links in the products suggestions sidebar
 */
(function() {
  'use strict';

  function initCollectionsRenderer() {
    // Look for the search-specific data script first, fall back to the mobile nav one
    const dataScript = document.getElementById('search-products-suggestions-data') || document.getElementById('products-suggestions-data');
    if (!dataScript) {
      return;
    }
    
    try {
      const data = JSON.parse(dataScript.textContent);
      
      function renderCollections(containerId, collections) {
        if (!collections || collections.length === 0) {
          const container = document.getElementById(containerId);
          if (container) {
            const column = container.closest('.products-suggestions__column');
            if (column) {
              column.style.display = 'none';
            }
          }
          return;
        }
        
        const container = document.getElementById(containerId);
        if (!container) {
          return;
        }
        
        // Clear existing content
        container.innerHTML = '';
        
        collections.forEach(collection => {
          const link = document.createElement('a');
          link.href = collection.url;
          link.className = 'products-suggestions__item';
          link.textContent = collection.title;
          link.title = collection.title;
          container.appendChild(link);
        });
      }
      
      renderCollections('main-collections-items', data.main_collections);
      renderCollections('jewelry-collections-items', data.jewelry_collections);
    } catch (e) {
      // Silently handle parsing errors - data script may not be available or malformed
      console.debug('Collections data not available:', e);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionsRenderer);
  } else {
    initCollectionsRenderer();
  }
})();

